/** Moment (0..1) at which a line drawn with power2.inOut reaches a fraction of its length. */
export function reachTime(fraction: number): number {
	const x = Math.min(1, Math.max(0, fraction));
	return x < 0.5 ? Math.sqrt(x / 2) : 1 - Math.sqrt((1 - x) / 2);
}
